<div class="col-xl incidents-wrap" *ngIf="employeeId">
    <div class="employee-breadcrumb mb-3">
        <a [routerLink]="['/employee/list']">Listado de colaboradores</a> /
        <a [routerLink]="['/employee', employeeId]">{{employee ? getEmployeeName() : 'Detalles del colaborador'}}</a> /
        <span class="current">Registro de incidencias</span>
    </div>

    <div class="d-flex align-items-center justify-content-between mb-4 flex-wrap gap-3">
        <div class="d-flex align-items-center gap-3">
            <button type="button" class="employee-back-btn" (click)="goBack()" title="Regresar">
                <i class="ti ti-arrow-left"></i>
            </button>
            <div class="employee-avatar">
                <img *ngIf="photoUrl" [src]="photoUrl" alt="Foto del colaborador">
                <span *ngIf="!photoUrl">{{initials}}</span>
            </div>
            <div *ngIf="employee">
                <div class="d-flex align-items-center gap-2 flex-wrap">
                    <h4 class="mb-0 employee-name">{{getEmployeeName()}}</h4>
                    <span class="employee-status-badge" [class.is-active]="statusIsActive" [class.is-inactive]="!statusIsActive">
                        <span class="dot"></span>{{statusLabel}}
                    </span>
                </div>
                <p class="employee-subtitle mb-0">
                    {{employee.position?.name || 'Sin puesto'}} &nbsp;|&nbsp; {{employee.department?.name || 'Sin departamento'}} &nbsp;|&nbsp; Ingreso: {{formatDate(employee.hire_date)}}
                </p>
            </div>
        </div>

        <button type="button" class="incidents-terminate-btn" *ngIf="statusIsActive && canDo('Dar de baja')" (click)="openTerminationModal()">
            <img src="assets/img/icons/inc-user-block.svg" alt=""> Dar de baja
        </button>
    </div>

    <div class="incidents-columns">
        <div class="incidents-main-col">
            <div class="kpi-row">
                <div class="kpi-card">
                    <span class="kpi-icon-badge" style="background:#fee2e2;"><img src="assets/img/icons/inc-user-minus.svg" alt=""></span>
                    <div class="kpi-body">
                        <p class="kpi-label">Faltas del mes</p>
                        <p class="kpi-value">{{faltasDelMes}} <span class="kpi-unit">Días</span></p>
                    </div>
                </div>
                <div class="kpi-card">
                    <span class="kpi-icon-badge" style="background:#f5f3ff;"><img src="assets/img/icons/inc-briefcase-purple.svg" alt=""></span>
                    <div class="kpi-body">
                        <p class="kpi-label">Incapacidades</p>
                        <p class="kpi-value">{{incapacidadesCount}} <span class="kpi-unit">Evento</span></p>
                    </div>
                </div>
                <div class="kpi-card">
                    <span class="kpi-icon-badge" style="background:#e8fcf7;"><img src="assets/img/icons/inc-sun.svg" alt=""></span>
                    <div class="kpi-body">
                        <p class="kpi-label">Vacaciones</p>
                        <p class="kpi-value">{{vacacionesDias}} <span class="kpi-unit">Días</span></p>
                    </div>
                </div>
                <div class="kpi-card">
                    <span class="kpi-icon-badge" style="background:#fdf4e8;"><img src="assets/img/icons/inc-file-text-amber.svg" alt=""></span>
                    <div class="kpi-body">
                        <p class="kpi-label">Permisos</p>
                        <p class="kpi-value">{{permisosDias}} <span class="kpi-unit">Días</span></p>
                    </div>
                </div>
            </div>

            <div class="incidents-panel">
                <div class="calendar-header">
                    <div class="calendar-nav-group">
                        <button type="button" class="calendar-nav-btn" (click)="prevMonth()" aria-label="Mes anterior">
                            <i class="ti ti-chevron-left"></i>
                        </button>
                        <button type="button" class="calendar-today-btn" (click)="goToToday()">Hoy</button>
                        <button type="button" class="calendar-nav-btn" (click)="nextMonth()" aria-label="Mes siguiente">
                            <i class="ti ti-chevron-right"></i>
                        </button>
                    </div>
                    <div class="calendar-month-label">
                        {{monthLabel}}
                        <img src="assets/img/icons/inc-chevron-down.svg" alt="">
                    </div>
                </div>

                <div class="calendar-grid">
                    <div class="calendar-weekdays">
                        <span *ngFor="let wd of weekdayLabels">{{wd}}</span>
                    </div>
                    <div class="calendar-week" *ngFor="let week of calendarWeeks">
                        <button type="button" *ngFor="let cell of week" class="calendar-day"
                            [class.is-empty]="!cell" [class.is-selected]="isSelected(cell)"
                            [class.is-in-range]="isInRange(cell)"
                            [disabled]="!cell" (click)="selectDay(cell)">
                            <span class="calendar-day-number" [class.saturday]="isWeekend(cell) === 'saturday'" [class.sunday]="isWeekend(cell) === 'sunday'">{{cell?.day}}</span>
                            <span class="calendar-day-dots" *ngIf="cell?.dots?.length">
                                <span class="calendar-dot" *ngFor="let color of cell?.dots" [style.background]="color"></span>
                            </span>
                        </button>
                    </div>
                </div>

                <div class="calendar-legend">
                    <span *ngFor="let item of legendItems" class="calendar-legend-item">
                        <span class="calendar-dot" [style.background]="item.color"></span>{{item.label}}
                    </span>
                </div>
            </div>

            <div class="incidents-panel">
                <h5 class="mb-0 incidents-title">Historial de incidencias</h5>

                <div class="incidents-table-wrap" *ngIf="!loading && !loadError">
                    <table class="incidents-table">
                        <thead>
                            <tr>
                                <th>Fecha</th>
                                <th>Tipo incidencia</th>
                                <th class="text-center">Días</th>
                                <th class="text-center">Registrado por</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of visibleRows">
                                <td>{{formatDate(row.date)}}</td>
                                <td>
                                    <span class="incidents-type-dot" [style.background]="incidentColor(row.incident_type)"></span>
                                    {{incidentLabel(row.incident_type)}}
                                </td>
                                <td class="text-center">{{row.days}}</td>
                                <td class="text-center">{{row.recorded_by?.name || '--'}}</td>
                            </tr>
                            <tr *ngIf="!rows.length">
                                <td colspan="4" class="text-center text-muted py-4">Sin incidencias registradas</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="incidents-empty-state" *ngIf="loading">
                    <i class="ti ti-loader-2"></i>
                    <p class="mb-0">Cargando historial de incidencias...</p>
                </div>

                <div class="incidents-empty-state" *ngIf="loadError">
                    <i class="ti ti-file-x"></i>
                    <p class="mb-0">No se pudo cargar el historial de incidencias.</p>
                </div>

                <button type="button" class="incidents-history-link" *ngIf="rows.length > 3" (click)="toggleHistory()">
                    {{showAllHistory ? 'Ver menos' : 'Ver historial completo'}}
                    <img src="assets/img/icons/inc-arrow-right.svg" alt="">
                </button>
            </div>
        </div>

        <div class="incidents-drawer">
            <h5 class="incidents-drawer-title">{{selectedIncident ? 'Editar incidencia' : 'Registrar incidencia'}}</h5>

            <div class="incidents-drawer-date">
                <img src="assets/img/icons/inc-calendar-03.svg" alt="">
                <span>{{selectedDateLabel}}</span>
            </div>

            <form [formGroup]="form" (ngSubmit)="save()">
                <label class="field-label">Tipo de incidencia</label>
                <div class="type-buttons-grid">
                    <button type="button" class="type-button" *ngFor="let t of typeButtons"
                        [class.is-active]="f['incident_type'].value === t.value"
                        [style.--type-color]="t.color" [style.--type-bg]="t.iconBg"
                        (click)="selectType(t.value)">
                        <img [src]="'assets/img/icons/' + t.icon" alt="">
                        <span>{{t.label}}</span>
                    </button>
                </div>

                <ng-container *ngIf="isIncapacidad">
                    <div class="field-block">
                        <label class="field-label">Tipo de incapacidad</label>
                        <select class="field-select" formControlName="incapacity_type">
                            <option value="">Seleccionar</option>
                            <option *ngFor="let opt of incapacityTypes" [value]="opt">{{opt}}</option>
                        </select>
                    </div>

                    <div class="field-block">
                        <label class="field-label">Folio del certificado IMSS</label>
                        <div class="field-input-group">
                            <input type="text" class="field-input" formControlName="imss_certificate_number" placeholder="Ingresar">
                            <img src="assets/img/icons/inc-help-circle.svg" class="field-help-icon" alt=""
                                title="Número de folio del certificado de incapacidad emitido por el IMSS">
                        </div>
                    </div>

                    <div class="field-block">
                        <label class="field-label">% a cargo del IMSS</label>
                        <div class="field-input-group">
                            <input type="number" min="0" max="100" class="field-input" formControlName="imss_percentage" placeholder="0">
                            <img src="assets/img/icons/inc-help-circle.svg" class="field-help-icon" alt=""
                                title="Porcentaje del salario que cubre el IMSS durante la incapacidad">
                        </div>
                    </div>
                </ng-container>

                <div class="field-block" *ngIf="isFaltaInjustificada">
                    <label class="field-label">Fecha de la falta injustificada</label>
                    <input type="date" class="field-input" formControlName="start_date">
                </div>

                <div class="field-row-2" *ngIf="!isFaltaInjustificada">
                    <div class="field-block">
                        <label class="field-label">Fecha de inicio</label>
                        <input type="date" class="field-input" formControlName="start_date">
                    </div>
                    <div class="field-block">
                        <label class="field-label">Fecha de fin</label>
                        <input type="date" class="field-input" formControlName="end_date">
                    </div>
                </div>

                <div class="field-block" *ngIf="isIncapacidad">
                    <label class="field-label">Días de incapacidad</label>
                    <div class="field-static">{{computedDays !== null ? computedDays : 'Ingresa una fecha de inicio y fin'}}</div>
                </div>

                <div class="field-block" *ngIf="isIncapacidad">
                    <label class="field-label">% a cargo del patrón</label>
                    <div class="field-input-group">
                        <input type="number" min="0" max="100" class="field-input" formControlName="employer_percentage" placeholder="0">
                        <img src="assets/img/icons/inc-help-circle.svg" class="field-help-icon" alt=""
                            title="Porcentaje del salario que cubre el patrón durante la incapacidad">
                    </div>
                </div>

                <div class="field-block">
                    <label class="field-label">Observaciones</label>
                    <textarea class="field-textarea" formControlName="comment" maxlength="250" placeholder="Ingresar"></textarea>
                    <span class="field-char-count">{{commentLength}} / 250</span>
                </div>

                <div class="incidents-drawer-footer">
                    <button type="button" class="incidents-btn incidents-btn-danger" *ngIf="selectedIncident && canDo('Eliminar incidencia')" (click)="deleteIncident()">
                        <img src="assets/img/icons/inc-trash.svg" alt=""> Eliminar incidencia
                    </button>
                    <div class="incidents-drawer-actions">
                        <button type="button" class="incidents-btn incidents-btn-secondary" (click)="resetForm()">Limpiar</button>
                        <button type="submit" class="incidents-btn incidents-btn-primary" *ngIf="canDo('Registrar incidencia')">{{selectedIncident ? 'Guardar cambios' : 'Registrar incidencia'}}</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<app-termination-modal #terminationModal modalId="incidentsTerminationModal" (terminated)="onEmployeeTerminated($event)"></app-termination-modal>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>
